import { Box } from '@mui/material';
import { IconUtils } from '@/common/utils/IconUtils';
import { useMemo } from 'react';
import { ExportButton } from '../../buttons/ExportButton';
import { Title } from '../../title/Title';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';

export const EntityTitle = ({ buttons }) => {
const { entityDef, exportReq, hist, entityObj, entityFormMode, breadcrumbs } = useEntityMgr();

  const icon = useMemo(
    () => IconUtils.iconFromIconStr(entityDef.icon),
    [entityDef.icon]
  );
  const title = entityDef
    ? entityDef.displayName + (hist ? ' History' : '')
    : '';

  const defaultBreadcrumbs = useMemo(() => {
    if (!entityObj || Object.keys(entityObj).length === 0) return null;
    return [entityObj.name ?? entityObj.code];
  }, [entityObj?.name, entityObj?.code]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Title
        icon={icon}
        title={title}
        breadcrumbs={breadcrumbs ?? defaultBreadcrumbs}
      />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {/* Buttons set by parent component (Detail, List, etc.) */}
        {buttons}

        {/* Export Button */}
        {(!entityFormMode || entityFormMode !== EntityFormMode.ADD) && (
          <ExportButton exportReq={exportReq} />
        )}
      </Box>
    </Box>
  );
};
